const convertToyyyyMMddThhmm = (value) => {
  // If value is not valid date, return empty string
  if (!Date.parse(value)) return "";

  // Create a date object
  const dateTime = new Date(value);

  // Adjust the date object to the local time zone
  const offset = dateTime.getTimezoneOffset(); // Get the timezone offset in minutes
  const localTime = new Date(dateTime.getTime() - offset * 60000); // Adjust to local time

  // Format the date to YYYY-MM-DDThh:mm
  const year = localTime.getFullYear();
  const month = String(localTime.getMonth() + 1).padStart(2, "0");
  const day = String(localTime.getDate()).padStart(2, "0");
  const hours = String(localTime.getHours()).padStart(2, "0");
  const minutes = String(localTime.getMinutes()).padStart(2, "0");

  return `${year}-${month}-${day}T${hours}:${minutes}`;
};

export default convertToyyyyMMddThhmm;
